import React from "react";
import GlassCard from "@/components/common/GlassCard";
import { Button } from "@/components/ui/button";

export default function SEODiscovery({ job, onStart, onImport, onIgnore, selected, onToggle, running }) {
  const results = job?.results || [];
  const newOnes = results.filter((r) => r.state === "new");
  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <Button onClick={() => onStart(true)} disabled={running} className="btn-gradient text-white border-0">{running ? "Discovering…" : "Discover website"}</Button>
        <Button variant="ghost" className="text-white/70" onClick={() => onStart(false)} disabled={running}>CMS only</Button>
        <Button variant="ghost" className="text-white/70" onClick={onImport} disabled={!selected.size}>Add selected</Button>
        <Button variant="ghost" className="text-white/70" onClick={onIgnore} disabled={!selected.size}>Ignore selected</Button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
        {[["Discovered", results.length], ["Managed", results.filter((r) => r.state === "managed").length], ["New", newOnes.length], ["Failed", results.filter((r) => r.state === "failed").length]].map(([l, v]) => (
          <GlassCard key={l} className="p-4"><div className="text-white/40 text-xs uppercase">{l}</div><div className="text-2xl text-white">{v}</div></GlassCard>
        ))}
      </div>
      <GlassCard className="p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase text-white/40"><tr><th className="px-4 py-2" /><th className="px-4 py-2 text-left">Path</th><th className="px-4 py-2 text-left">Source</th><th className="px-4 py-2 text-left">State</th></tr></thead>
          <tbody>
            {results.map((r) => (
              <tr key={r.path} className="border-t border-white/5">
                <td className="px-4 py-2"><input type="checkbox" checked={selected.has(r.path)} onChange={(e) => onToggle(r.path, e.target.checked)} disabled={r.state === "managed"} aria-label={r.path} /></td>
                <td className="px-4 py-2 font-mono text-xs text-white">{r.path}</td>
                <td className="px-4 py-2 text-white/50">{r.source}</td>
                <td className="px-4 py-2 text-white/60">{r.state}</td>
              </tr>
            ))}
            {results.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-white/40">Run discovery to list sitemap, CMS, and navigation URLs.</td></tr>}
          </tbody>
        </table>
      </GlassCard>
    </div>
  );
}
